import { lazy } from 'react';

// Identity Lifecycle (Onboarding/Offboarding)
export const IdentityLifecycleDashboard = lazy(() =>
  import('@/workflows/customer-onboarding/pages/identity-lifecycle/IdentityLifecycleDashboard').then(
    (m) => ({ default: m.IdentityLifecycleDashboard })
  )
);

export const OnboardingWizard = lazy(() =>
  import('@/workflows/customer-onboarding/pages/identity-lifecycle/OnboardingWizard').then((m) => ({
    default: m.OnboardingWizard,
  }))
);

export const OffboardingWizard = lazy(() =>
  import('@/workflows/customer-onboarding/pages/identity-lifecycle/OffboardingWizard').then(
    (m) => ({ default: m.OffboardingWizard })
  )
);

export const WorkflowProgress = lazy(() =>
  import('@/workflows/customer-onboarding/pages/identity-lifecycle/WorkflowProgress').then((m) => ({
    default: m.WorkflowProgress,
  }))
);
